import React from "react"
import { FaRegEdit } from "react-icons/fa";
import { useUsuario } from "../../../../../context/Suporte/CadastroUsuarioContext";
import { useModal } from "../../../../../hooks/ModalContext";
import { Usuario } from "../../../../../types/supervisao/usuario-interface";

export const ListaUsuarios = () => {
  const { usuarios } = useUsuario()
  const { setModal, setInfoUsuario } = useModal()

  const dividirEmLinhas = (texto: string) => {
    if (texto) return texto.match(/.{1,30}/g)?.join('\n') || [];
  };

  function atualizaButton(user: Usuario) {
    setInfoUsuario(user)
    setModal('Atualiza Usuario', 'Atualiza Usuario')
  }

  return (
    <div className={`flex max-h-full min-h-full  w-full flex-col items-center rounded-md bg-white px-4 py-4`}>
      <div className="my-2 min-w-full">
        <div className="flex flex-col">
          <div className="overflow-x-auto">
            <div className="inline-block w-full p-1.5 align-middle">
              <div className="max-h-[600px] overflow-hidden overflow-y-auto rounded-lg border ">
                <table className="table-row-color min-w-full divide-y divide-gray-200 ">
                  <thead className="sticky top-0 bg-primary h-10">
                    <tr>
                      <th scope="col" className="th-cadastro">
                        Login
                      </th>
                      <th scope="col" className="th-cadastro">Nome</th>
                      <th scope="col" className="th-cadastro">Perfil</th>
                      <th scope="col" className="th-cadastro">E-mail</th>
                      <th scope="col" className="th-cadastro">Credores</th>
                      <th scope="col" className="th-cadastro">UsuarioDiscador</th>
                      <th scope="col" className="th-cadastro">SenhaDiscador</th>
                      <th scope="col" className="th-cadastro">Token</th>
                      <th scope="col" className="th-cadastro">Editar</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 ">
                    {
                      usuarios && usuarios?.length > 0 && usuarios.map(user => (
                        <tr key={user.id_user} className="">
                          <td className="td-cadastro">
                            {user.login}
                          </td>
                          <td className="td-cadastro max-w-[150px] text-left"><p className=" wrap-text py-2">{user.name}</p></td>
                          <td className="td-cadastro text-left">{user?.perfil?.map(u => (<p key={u}>{u}</p>))}</td>
                          <td className="td-cadastro text-left truncate text-ellipsis max-w-[400px]">{user.email}</td>
                          <td className="td-cadastro text-left max-w-[250px]">
                            <ul className="list-disc">
                              {
                                user?.credores?.map(credor => (
                                  <li className=" wrap-text " key={credor.id_credor}>{credor.credor}</li>
                                ))
                              }
                            </ul>
                          </td>
                          <td className="td-cadastro max-w-[200px] text-left"><p className=" wrap-text py-2">{user.usuarioDiscador}</p></td>
                          <td className="td-cadastro max-w-[200px] text-left"><p className=" wrap-text py-2">{user.senhaDiscador}</p></td>
                          <td className="td-cadastro  max-w-[250px] text-left">
                            <p className="wrap-text">{dividirEmLinhas(user?.urlDiscador)}</p>
                          </td>
                          <td className="td-cadastro">
                            <button onClick={() => atualizaButton(user)}>
                              <FaRegEdit className="fill-primary" size={20} />
                            </button>
                          </td>
                        </tr>
                      ))
                    }

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>


      </div >
    </div >
  )
}